import "./construction.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { wrenchIcon } from "@tql/ui-components-react/kendo/svg-icons";

import { ConstructionButton } from "./construction-button.tsx";

export type ConstructionProps = {
	readonly title?: string;
	readonly message?: string;
	readonly className?: string;
	readonly routingEnabled?: boolean;
};

export const Construction = ({
	title = "Under Construction",
	message = "This feature is currently being developed and will be available soon.",
	className = "",
	routingEnabled = true,
}: ConstructionProps) => {
	return (
		<div className={`construction ${className}`} data-testid={"construction"}>
			<div className={"construction-content"}>
				<SvgIcon className={"construction-icon"} icon={wrenchIcon} />
				<h2 className={"construction-title"}>{title}</h2>
				<p className={"construction-message"}>{message}</p>
				<div className={"construction-button"}></div>
				{routingEnabled ? <ConstructionButton /> : null}
			</div>
		</div>
	);
};
